var matcHeight = function matcHeight() {
	var $ = require('jquery');
	require('jquery-match-height');

	$(".why__block span").matchHeight();
	$('.match-height').matchHeight();
	$('.news-list').matchHeight();
	$('.news-list h4').matchHeight();
	$('.news-list__content__main').matchHeight();
	$(".member-list").matchHeight();
	$(".member-list__about").matchHeight();
	$(".member-list__upper").matchHeight();
	$('.our-members__block p').matchHeight();
	$('.our-members__block').matchHeight();
	$('.our-members__block h3').matchHeight();
}
module.exports = matcHeight;
